import $ from "jquery";
import Swiper from 'swiper/bundle';

export default function imageSwiper() {
    $('.avuImageSwiper').each(function() {
        const swiperElement = $(this);
        const swiperId = swiperElement.attr('id');

        new Swiper(swiperElement[0], {
            rewind: true,
            pagination: {
                el: `#${swiperId}-pagination`,
                clickable: true,
                type: 'bullets',
            },
            navigation: {
                nextEl: `#${swiperId}-next`,
                prevEl: `#${swiperId}-prev`,
            },
        });
    });
}
